/**
 * PM International
 *
 * Styles according to the Feidekai guidelines.
 */

import { ReactNode } from 'react';

import { cn } from '@foundation/utils/cn';

interface ITypographyProps {
  readonly variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'span' | 'p' | 'small';
  readonly className?: string;
  readonly children: ReactNode;
}

export function Typography({
  variant = 'span',
  children,
  className,
}: ITypographyProps) {
  if (variant === 'h1') {
    return <Heading1 className={className}>{children}</Heading1>;
  }

  if (variant === 'h2') {
    return <Heading2 className={className}>{children}</Heading2>;
  }

  if (variant === 'h3') {
    return <Heading3 className={className}>{children}</Heading3>;
  }

  if (variant === 'h4') {
    return <Heading4 className={className}>{children}</Heading4>;
  }

  if (variant === 'h5') {
    return <Heading5 className={className}>{children}</Heading5>;
  }

  if (variant === 'p') {
    return <Paragraph className={className}>{children}</Paragraph>;
  }

  if (variant === 'small') {
    return <Small className={className}>{children}</Small>;
  }

  if (variant === 'span') {
    return <Span className={className}>{children}</Span>;
  }

  return null;
}

interface IHeadingProps {
  readonly children: ReactNode;
  readonly className?: string;
}

function Heading1({ children, className }: IHeadingProps) {
  return <h1 className={cn('heading-1', className)}>{children}</h1>;
}

function Heading2({ children, className }: IHeadingProps) {
  return <h2 className={cn('heading-2', className)}>{children}</h2>;
}

function Heading3({ children, className }: IHeadingProps) {
  return <h3 className={cn('heading-3', className)}>{children}</h3>;
}

function Heading4({ children, className }: IHeadingProps) {
  return <h4 className={cn('heading-4', className)}>{children}</h4>;
}

function Heading5({ children, className }: IHeadingProps) {
  return <h5 className={cn('heading-5', className)}>{children}</h5>;
}

function Paragraph({ children, className }: IHeadingProps) {
  return <p className={className}>{children}</p>;
}

function Small({ children, className }: IHeadingProps) {
  return (
    <small className={cn('text-xs lg:text-sm', className)}>{children}</small>
  );
}

function Span({ children, className }: IHeadingProps) {
  return <span className={className}>{children}</span>;
}
